// extracted by mini-css-extract-plugin
export var brand = "_55-9";
export var compact = "_55-6";
export var extraSmall = "_55-7";
export var icon = "_55-0";
export var large = "_55-4";
export var light = "_55-1";
export var medium = "_55-5";
export var outline = "_55-b";
export var primaryDark = "_55-a";
export var primaryLight = "_55-8";
export var primaryModern = "_55-c";
export var success = "_55-2";
export var successSolid = "_55-3";